import { Modal } from "@leagueplatform/genesis-core";
import { QUERY_PARAM_KEYS, QUERY_PARAM_MODAL_VALUE } from "common/constants";
import { AccountDeletedModal } from "components/modals/account-deleted-modal.component";
import { DeleteAccountModal } from "components/modals/delete-account-modal.component";
import { useUrlParam } from "hooks/use-url-param.hook";

const QUERY_PARAM_MODAL_MAPPING: Record<string, React.ElementType | undefined> =
  {
    [QUERY_PARAM_MODAL_VALUE.DELETE_ACCOUNT]: DeleteAccountModal,
  };

const QUERY_PARAM_MODAL_MAPPING_PUBLIC: Record<
  string,
  React.ElementType | undefined
> = {
  [QUERY_PARAM_MODAL_VALUE.DELETE_ACCOUNT_DISCLAIMER]: AccountDeletedModal,
};

export const QueryParamModal = ({ isPublic }: { isPublic?: boolean }) => {
  const { removeParam, urlParam } = useUrlParam(QUERY_PARAM_KEYS.MODAL, true);

  const modalMapping = isPublic
    ? QUERY_PARAM_MODAL_MAPPING_PUBLIC
    : QUERY_PARAM_MODAL_MAPPING;

  if (!urlParam) {
    return null;
  }

  const Component = modalMapping[
    urlParam as keyof typeof QUERY_PARAM_MODAL_VALUE
  ] as React.ElementType;

  if (!Component) {
    return null;
  }

  return (
    <Modal.Root open={!!urlParam} onOpenChange={removeParam}>
      <Component onClose={removeParam} />
    </Modal.Root>
  );
};
